import { useQuery } from "@tanstack/react-query";
import { DEFAULT_ADMIN_PAGE_SIZE } from "src/constants";
import cmsClient from "src/services/cmsClient";
import { adaptGroups } from "../adapters/adaptGroup";

interface UseAdminGroupsParams {
	page?: number;
	pageSize?: number;
}

const fetchAdminGroups = async ({
	page = 1,
	pageSize = DEFAULT_ADMIN_PAGE_SIZE
}: UseAdminGroupsParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IGroup>>(
		"/users/groups/",
		{
			params: {
				page,
				page_size: pageSize
			}
		}
	);

	return response.data.results;
};

const useAdminGroups = ({
	page = 1,
	pageSize = DEFAULT_ADMIN_PAGE_SIZE
}: UseAdminGroupsParams = {}) => {
	const query = useQuery(
		["admin-groups", { page, pageSize }],
		() => fetchAdminGroups({ page, pageSize }),
		{
			select: adaptGroups
		}
	);

	return query;
};

export default useAdminGroups;
